import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/page/*',
			name: 'page',
			component: () => import("@/views/Page") 
		},
		{ 
			path: '/preloader',
			name: 'preloader',
			component: () => import("@/views/Preloader") 
		}	
	]
})
